import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {ClientProps} from "@/interfaces/client_types.ts";
import {getClientById} from "@/api/client.ts";
import {ClientForm} from "@/components/Clients/Form/ClientForm.tsx";
import { RouteButton } from "../Buttons";
import { GenericTableFactory } from "../_Shared/Table/Classes/Factory";

/**
 *  Route for "/clients/create_client"
 * 
 */
export function CreateClient() {
    return (
        <ClientForm method={"POST"} />
    )
}

/**
 *  Route for "/clients/update_client/:id"
 * 
 */
export function UpdateClient() {
    const { id } = useParams()

    const [currentClient, setCurrentClient] = useState<ClientProps>()

    useEffect(() => {
        if (!id) return

        const fetchClient = async () => {
            try {
                const data = await getClientById(id)
                setCurrentClient(data.data)
            } catch (error) {
                console.error("Error fetching client:", error)
            }
        }

        fetchClient()
    }, [id])

    return (
        <>
            {currentClient && <ClientForm method={"PUT"} formProps={currentClient}/>}
        </>
    )
}

/**
 *  Route for "/clients/list"
 * 
 */
export function ClientList() {
    const table = GenericTableFactory.createClientTable()
    
    return (
        <>
            <div className="py-5 pl-5">
                <h1>Clients</h1>
            </div>

            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/clients/list"} text="Back" />
            </div>
        </>
    )
}
